import { CreateProfilePage } from "@circle-react/components/OnboardingPage/CreateProfilePage";
import { OtpSignInPage } from "@circle-react/components/OnboardingPage/OtpSignInPage";
import { ResetPasswordPage } from "@circle-react/components/OnboardingPage/ResetPasswordPage";
import type { SignInResponse } from "@circle-react/hooks/useVerifyOtp";

export interface SignUpProps {
  hasEmail: boolean;
  otpSignInResponse: SignInResponse | null;
  setOtpSignInResponse: (response: SignInResponse) => void;
}

export const SignUp = ({
  hasEmail = false,
  otpSignInResponse,
  setOtpSignInResponse,
}: SignUpProps) => {
  if (!hasEmail) {
    return <CreateProfilePage />;
  }

  if (otpSignInResponse) {
    return <ResetPasswordPage otpSignInResponse={otpSignInResponse} />;
  }

  return <OtpSignInPage setOtpSignInResponse={setOtpSignInResponse} />;
};

export default SignUp;
